export function HeroIllustration() {
  return (
    <svg
      viewBox="0 0 480 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full max-w-lg"
      aria-hidden="true"
    >
      {/* Connection lines */}
      <line x1="240" y1="140" x2="120" y2="80" stroke="hsl(221 83% 53% / 0.4)" strokeWidth="1.5" strokeDasharray="4 3" />
      <line x1="240" y1="140" x2="360" y2="80" stroke="hsl(221 83% 53% / 0.4)" strokeWidth="1.5" strokeDasharray="4 3" />
      <line x1="240" y1="220" x2="100" y2="300" stroke="hsl(160 84% 39% / 0.4)" strokeWidth="1.5" strokeDasharray="4 3" />
      <line x1="240" y1="220" x2="380" y2="300" stroke="hsl(160 84% 39% / 0.4)" strokeWidth="1.5" strokeDasharray="4 3" />
      <line x1="240" y1="220" x2="240" y2="320" stroke="hsl(160 84% 39% / 0.4)" strokeWidth="1.5" strokeDasharray="4 3" />

      {/* Central org node */}
      <circle cx="240" cy="180" r="40" fill="hsl(221 83% 53% / 0.15)" stroke="hsl(221 83% 53%)" strokeWidth="2" />
      <rect x="222" y="162" width="36" height="36" rx="6" fill="hsl(221 83% 53% / 0.3)" />

      {/* Member nodes */}
      <circle cx="120" cy="70" r="24" fill="hsl(160 84% 39% / 0.15)" stroke="hsl(160 84% 39%)" strokeWidth="1.5" />
      <circle cx="360" cy="70" r="24" fill="hsl(160 84% 39% / 0.15)" stroke="hsl(160 84% 39%)" strokeWidth="1.5" />
      <circle cx="100" cy="310" r="20" fill="hsl(160 84% 39% / 0.15)" stroke="hsl(160 84% 39%)" strokeWidth="1.5" />
      <circle cx="380" cy="310" r="20" fill="hsl(160 84% 39% / 0.15)" stroke="hsl(160 84% 39%)" strokeWidth="1.5" />
      <circle cx="240" cy="330" r="20" fill="hsl(160 84% 39% / 0.15)" stroke="hsl(160 84% 39%)" strokeWidth="1.5" />

      {/* Checkmarks on top member nodes */}
      <path d="M113 70 l5 5 9-9" stroke="hsl(160 84% 39%)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M353 70 l5 5 9-9" stroke="hsl(160 84% 39%)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />

      {/* Floating stat badges */}
      <rect x="320" y="150" width="100" height="32" rx="8" fill="hsl(221 83% 53% / 0.1)" stroke="hsl(221 83% 53% / 0.3)" />
      <text x="370" y="170" textAnchor="middle" fontSize="11" fill="hsl(221 83% 53%)" fontWeight="600">128 Members</text>

      <rect x="58" y="150" width="86" height="32" rx="8" fill="hsl(160 84% 39% / 0.1)" stroke="hsl(160 84% 39% / 0.3)" />
      <text x="101" y="170" textAnchor="middle" fontSize="11" fill="hsl(160 84% 39%)" fontWeight="600">95% Rate</text>
    </svg>
  );
}
